/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Documents/view.blocks to change it.
import * as fromData from 'Simple/Data'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Navigation from './Navigation/index'
import React from 'react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import styles from './view.module.css'
let FilesTree = React.lazy(() => import('./FilesTree/index'))
let Preview = React.lazy(() => import('./Preview/index'))



/** @type {import('Simple/types.js').View} */
export default function Documents({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Documents"
  
}) {
let tabPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'patient_id',
})
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
 data="tab.patient_id"
 patientId={tabPatientIdValueData}
 patientTab="documents"
/>
<Navigation
  viewPath={`${viewPath}/Navigation`}
/>
<div
  data-testid="Documents.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<SuspenseBoundary
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<React.Fragment>
<FilesTree
{...childProps}
  viewPath={`${viewPath}/FilesTree`}
/>
<Preview
{...childProps}
  viewPath={`${viewPath}/Preview`}
/>
</React.Fragment>
)}
</SuspenseBoundary>
</div>
{children}
</React.Fragment>)
}